import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { i18next } from '@frontend/i18n';

export const getTimeIn12HrFormat = (date: string, time: string) => {
  return dayjs(`${date} ${time}`).format('h:mmA');
};

export const isEndTimeBeforeStartTime = (timeRange?: string[]) => {
  if (!isEmpty(timeRange)) {
    const [start, end] = timeRange || [];
    const startTime = dayjs(start, 'HH:mm');
    const endTime = dayjs(end, 'HH:mm');
    return endTime.isBefore(startTime);
  }
  return false;
};

export const defaultQuickFillTemplate = i18next.t(
  'Hello, {{FIRST_NAME}}, this is {{PRACTICE_NAME}}. We have last minute opening for {{DATE_TIME}}\n\nReply to schedule an appointment.',
  { ns: 'schedule-quick-fill' }
);

export const convertToIsoString = (date = '', time = '') => {
  const dateTime = dayjs(`${date} ${time}`, 'MM/DD/YYYY HH:mm:ss');
  return dateTime.isValid() ? dateTime.toISOString() : '';
};
